import axios from 'axios';
import { Config } from 'shared/lib/config';

export const BASE_URL = Config.REACT_APP_BACKEND_URL;

const httpClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export default httpClient;
